import React, { useEffect, useRef, useState } from "react";
import { FF, T } from "../lib/constants";

// Eén ⋯-knop met een uitklapmenu, in plaats van een rij losse ronde knopjes op een kaart.
// items: [{ label, icon, onClick, danger }]  (falsy items worden overgeslagen)
export default function ActionMenu({ items, size, style, center }) {
  var [open, setOpen] = useState(false);
  var ref = useRef(null);
  var list = (items || []).filter(Boolean);
  var s = size || 32;

  useEffect(function () {
    if (!open) return;
    function outside(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    function key(e) { if (e.key === "Escape") setOpen(false); }
    document.addEventListener("pointerdown", outside);
    document.addEventListener("keydown", key);
    return function () { document.removeEventListener("pointerdown", outside); document.removeEventListener("keydown", key); };
  }, [open]);

  if (!list.length) return null;
  return (
    <div ref={ref} style={Object.assign(center ? { position: "absolute", top: "50%", right: 10, marginTop: -s / 2, zIndex: open ? 60 : 2 } : { position: "absolute", top: 4, right: 4, zIndex: open ? 60 : 2 }, style)}
      onClick={function (e) { e.stopPropagation(); }}>
      <button onClick={function () { setOpen(!open); }} title="Opties" aria-label="Opties" aria-expanded={open}
        onMouseEnter={function (e) { if (!open) e.currentTarget.style.background = "#E7E3DA"; }}
        onMouseLeave={function (e) { if (!open) e.currentTarget.style.background = "#F0EDE6"; }}
        style={{ width: s, height: s, borderRadius: "50%", border: "none", background: open ? "#E7E3DA" : "#F0EDE6", color: open ? T.ink : "#7A766D", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
        <svg width="4" height="16" viewBox="0 0 4 16" aria-hidden="true" style={{ display: "block" }}>
          <circle cx="2" cy="2" r="1.8" fill="currentColor" /><circle cx="2" cy="8" r="1.8" fill="currentColor" /><circle cx="2" cy="14" r="1.8" fill="currentColor" />
        </svg>
      </button>
      {open && (
        <div role="menu" style={{ position: "absolute", top: s + 4, right: 0, minWidth: 250, background: "#fff", border: "1px solid " + T.line2, borderRadius: 12, boxShadow: "0 12px 32px rgba(0,0,0,.14)", padding: 4, fontFamily: FF }}>
          {list.map(function (it, i) {
            return (
              <button key={i} role="menuitem" onClick={function () { setOpen(false); it.onClick(); }}
                style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left", padding: "9px 10px", border: "none", background: "none", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, color: it.danger ? "#B83232" : T.ink, fontFamily: FF, borderTop: it.danger && i > 0 ? "1px solid " + T.line : "none" }}
                onMouseEnter={function (e) { e.currentTarget.style.background = it.danger ? "#FBEDEC" : T.soft; }}
                onMouseLeave={function (e) { e.currentTarget.style.background = "none"; }}>
                <span style={{ width: 18, textAlign: "center", flex: "none" }}>{it.icon}</span>{it.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
